var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 2000,
    height: 478,
    "data-id": "lg_uIwMRLEoYVT6Pl9uZb",
    "data-version": 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-padding": 20
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 8.536)scale(.96429)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 164 515.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 164 468.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.86 421.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.86 515.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.86 468.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 164 421.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 164 374.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.86 327.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 164 327.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.86 374.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.73 515.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.73 468.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.6 421.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.6 515.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.6 468.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.73 421.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.73 374.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.6 327.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.73 327.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.47 515.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.47 468.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.47 421.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.47 374.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.47 327.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.6 374.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.69 374.13)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.69 327.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.56 280.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.56 374.13)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.56 327.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.69 280.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.69 233.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.56 186.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 210.69 186.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 257.56 233.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.43 374.13)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.43 327.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.3 280.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.3 374.13)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.3 327.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.43 280.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.43 233.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.3 186.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 304.43 186.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.16 374.13)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.16 327.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.16 280.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.16 233.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.16 186.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.3 233.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.66 515.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.66 468.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.53 421.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.53 515.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.53 468.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.66 421.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.66 374.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.53 327.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 351.66 327.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 398.53 374.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 445.4 515.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 445.4 468.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 492.27 421.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 492.27 515.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 492.27 468.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 445.4 421.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 445.4 374.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 492.27 327.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 445.4 327.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 539.13 515.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 539.13 468.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 539.13 421.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 539.13 374.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 539.13 327.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 492.27 374.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 446.43 610.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 446.43 563.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 493.56 516.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 493.56 610.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 493.56 563.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 446.43 516.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 446.43 469.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 493.56 422.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 446.43 422.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 493.56 469.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 540.69 610.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 540.69 563.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 587.81 516.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 587.81 610.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 587.81 563.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 540.69 516.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 540.69 469.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 587.81 422.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 540.69 422.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 634.94 610.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 634.94 563.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 634.94 516.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 2,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 634.94 469.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 634.94 422.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.914,
    cy: -59.135,
    r: 10,
    fill: "#2c106a",
    transform: "matrix(2.7 0 0 2.7 587.81 469.3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400.5 399.33)"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "140%",
    height: "140%",
    x: "-20%",
    y: "-20%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    result: "oBlur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f75cff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "oBlur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M446.407-142.035q0 21.67-12.34 31.92-12.35 10.24-35.54 10.24-23.18 0-35.53-10.24-12.35-10.25-12.35-31.92v-1.52h34.78v1.35q0 7.89 2.94 11.25t8.99 3.36 8.99-3.36 2.94-11.25v-75.27h37.12Zm63.51-50.57q20.33 0 33.09 6.8 12.77 6.81 12.77 22.09v34.61q0 2.86 1.35 4.71 1.34 1.84 4.03 1.84h6.05v19.32q-.51.34-2.61 1.1-2.1.75-5.96 1.51-3.87.75-8.91.75-9.74 0-16.04-2.94t-8.65-8.14q-6.39 5.04-14.28 8.06-7.9 3.02-18.48 3.02-31.25 0-31.25-24.86 0-12.94 6.97-19.74t20.08-9.32q13.1-2.52 34.27-2.52v-4.37q0-5.21-3.61-7.9t-9.33-2.69q-5.2 0-8.98 1.85t-3.78 5.88v.67h-32.93q-.17-.84-.17-2.35 0-12.6 12.01-19.99t34.36-7.39m12.43 52.08q-14.28 0-21.08 3.11-6.81 3.1-6.81 8.31 0 8.4 11.43 8.4 6.55 0 11.5-3.53 4.96-3.52 4.96-8.73Zm101.64-52.08q21.84 0 35.36 9.32 13.53 9.33 13.53 28.48h-32.43q0-15.12-16.46-15.12t-16.46 18.98v9.58q0 18.81 17.13 18.81 17.14 0 17.14-15.45h31.08q0 19.32-13.53 28.73-13.52 9.4-35.36 9.4-23.35 0-36.62-11.76-13.28-11.76-13.28-34.6 0-22.85 13.28-34.61 13.27-11.76 36.62-11.76m112.06 0q24.36 0 37.21 11.42 12.85 11.43 12.85 34.95v5.71h-66.53q0 9.57 4.29 14.45 4.28 4.87 13.52 4.87 8.4 0 12.35-3.53t3.95-9.41h32.42q0 16.13-12.26 25.2-12.27 9.07-35.79 9.07-24.69 0-38.3-11.5-13.61-11.51-13.61-34.86 0-22.85 13.27-34.61t36.63-11.76m1.34 21.33q-15.79 0-17.64 14.96h32.59q0-6.89-3.95-10.92-3.94-4.04-11-4.04m98.28 14.61 28.39-33.94h38.98l-32.76 35.79 33.6 52.92h-37.97l-18.65-30.41-11.59 11.26v19.15h-33.43v-121.97h33.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 189.84,
    x: 346.167,
    y: -254.585,
    fill: "none",
    rx: 0,
    ry: 0
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "transparent",
    d: "M720 0h560v478H720z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d4a66d97742ef08128264be41a7ef40f.svg";
export { ForwardRef as ReactComponent };